import FusePageSimple from "@fuse/core/FusePageSimple";
import { styled } from "@mui/material/styles";

import EcommerceHeader from 'app/main/ecommerce/header/EcommerceHeader';
import EcommerceFooter from 'app/main/ecommerce/footer/EcommerceFooter';
import CheckoutContent from 'app/main/ecommerce/checkout/content/CheckoutContent';

const Root = styled(FusePageSimple)(({ theme }) => ({
    "& .FusePageSimple-topBg": {
        background: "unset"
    },
    minHeight: "unset",
    "& .FusePageSimple-contentCard": {
        backgroundColor: "unset",
        boxShadow: "unset"
    }
}));

function Checkout(props) {

    return (
        <div className="flex flex-col flex-auto min-h-screen min-w-0 relative z-10">
            <EcommerceHeader />
                <Root
                    content={
                       <div className="max-w-1366px m-auto">
                            <CheckoutContent />
                        </div>
                    }

                />
            <EcommerceFooter />
        </div>
    );
}

export default Checkout;

